import { useParams } from 'react-router-dom';
import { AppButton } from 'components/AppButton';
import { FloatingBlurredLayout } from 'components/layouts';
import { getTrans } from 'modules/i18n';
import { ModalName, useModal } from 'modules/modal';
import { useWeekDetails, useWeekPeriod } from 'modules/week-details';

export const FloatingButtons = () => {
  const { weekId } = useParams();
  const { weekPeriod, isWeekOpen } = useWeekPeriod();
  const { weekDetails } = useWeekDetails();
  const { open } = useModal();

  if (!weekPeriod) return null;

  // The company transfers shift times automatically — the API rejects talent
  // shift deletion for such assignments, so the button is disabled (same
  // treatment as a closed week).
  const shiftTimesManagedByCompany = Boolean(
    weekId && weekDetails?.assignments[weekId]?.shiftTimesManagedByCompany
  );

  return (
    <FloatingBlurredLayout>
      <AppButton
        color="error"
        variant="outlined"
        onClick={() => open(ModalName.deleteShift)}
        disabled={!isWeekOpen || shiftTimesManagedByCompany}
      >
        {getTrans('shiftDetailsPage.button.deleteShift')}
      </AppButton>
    </FloatingBlurredLayout>
  );
};
